import React, { useState, useEffect } from "react";
import {
  TextField,
  Box,
  Typography,
  Divider,
  FormControlLabel,
  Switch,
  Grid,
} from "@mui/material";

const ValidityPeriod = ({ currentCa, setCurrentCa }) => {
  // 🔹 Track whether validity is enabled (initially based on existing data)
  const [isValidityEnabled, setIsValidityEnabled] = useState(
    currentCa.startPeriod !== null && currentCa.endPeriod !== null
  );

  const [errors, setErrors] = useState({ start: "", end: "" });

  // 🎯 Handle Start Year Change
  const handleStartYearChange = (e) => {
    const value = e.target.value;
    if (value === "" || /^\d{0,4}$/.test(value)) {
      setCurrentCa({
        ...currentCa,
        startPeriod: value === "" ? null : parseInt(value, 10),
      });
      setErrors({ ...errors, start: "" });
    }
  };

  // 🎯 Handle End Year Change
  const handleEndYearChange = (e) => {
    const value = e.target.value;
    if (value === "" || /^\d{0,4}$/.test(value)) {
      setCurrentCa({
        ...currentCa,
        endPeriod: value === "" ? null : parseInt(value, 10),
      });
      setErrors({ ...errors, end: "" });
    }
  };

  // 🎯 Validate Start and End Year
  const validateYears = () => {
    let startError = "";
    let endError = "";

    if (
      currentCa.startPeriod &&
      currentCa.endPeriod &&
      currentCa.startPeriod >= currentCa.endPeriod
    ) {
      startError = "Start Year must be less than End Year.";
      endError = "End Year must be greater than Start Year.";
    }

    setErrors({ start: startError, end: endError });
  };

  // 🎯 Handle Toggle Change
  const handleToggleChange = () => {
    const newValidityState = !isValidityEnabled;
    setIsValidityEnabled(newValidityState);

    if (!newValidityState) {
      setCurrentCa({
        ...currentCa,
        startPeriod: null,
        endPeriod: null,
      });
      setErrors({ start: "", end: "" }); // Reset errors when disabling
    }
  };

  return (
    <Box>
      {/* 🔹 Section Title */}
      <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
        Validity Period
      </Typography>
      <Divider sx={{ mb: 2 }} />

      {/* 🔹 Toggle Switch */}
      <FormControlLabel
        control={
          <Switch
            checked={isValidityEnabled}
            onChange={handleToggleChange}
            color="primary"
          />
        }
        label="Set Validity Period"
      />

      {/* 🔹 Input Fields - Only Visible When Validity Period is Enabled */}
      {isValidityEnabled && (
        <Grid container spacing={2} mt={1} alignItems="center">
          {/* Start Year Input */}
          <Grid item xs={6}>
            <TextField
              type="number"
              label="Start Year"
              value={currentCa.startPeriod || ""}
              onChange={handleStartYearChange}
              onBlur={validateYears}
              error={!!errors.start}
              helperText={errors.start}
              inputProps={{ pattern: "\\d{4}" }}
              fullWidth
            />
          </Grid>

          {/* End Year Input */}
          <Grid item xs={6}>
            <TextField
              type="number"
              label="End Year"
              value={currentCa.endPeriod || ""}
              onChange={handleEndYearChange}
              onBlur={validateYears}
              error={!!errors.end}
              helperText={errors.end}
              inputProps={{ pattern: "\\d{4}" }}
              fullWidth
            />
          </Grid>
        </Grid>
      )}
    </Box>
  );
};

export default ValidityPeriod;
